import React, { useEffect, useRef, useState } from 'react';
import SimCardDownloadOutlinedIcon from '@mui/icons-material/SimCardDownloadOutlined';
import FilterListOutlinedIcon from '@mui/icons-material/FilterListOutlined';
import ViewColumnOutlinedIcon from '@mui/icons-material/ViewColumnOutlined';
import { Pagination } from '@mui/material';
import { formatDate } from '../../utils/dateTime';
import Loader from '../common/Loader/Loader';
import Tooltip from '@mui/material/Tooltip';
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 622,
  bgcolor: 'background.paper',
  boxShadow: 24,
  borderRadius: '20px',
  maxHeight: '90vh', // Adjust the height for scrolling
  overflow: 'auto', // Make content scrollable
  p: 4,
};

function SupportRequestTable({
  data,
  totalPages,
  currentPage,
  handlePageChange,
  itemsPerPage,
  loading,
  fetchData,
  searchTerm,
  setSearchTerm
}) {
  const abortControllerRef = useRef(null);
  const debounceTimeoutRef = useRef(null);
  const [visibleColumns, setVisibleColumns] = useState({
    email: true,
    fullName: true,
    concern: true,
    description: true,
    createdAt: true,
  });

  const handleColumnToggle = (column) => {
    setVisibleColumns((prev) => ({
      ...prev,
      [column]: !prev[column],
    }));
  };

  const filteredData = data.filter((item) => {
    const matchesSearch =
      item.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.fullName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.concern?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.description?.toLowerCase().includes(searchTerm.toLowerCase());

    return matchesSearch;
  });

  const columnHeaders = [
    { key: 'email', label: 'Email' },
    { key: 'fullName', label: 'Full Name' },
    { key: 'concern', label: 'Convern' },
    { key: 'createdAt', label: 'Created Date' },
  ];
  
    useEffect(() => {
      if (debounceTimeoutRef.current) {
        clearTimeout(debounceTimeoutRef.current);
      }
  
      debounceTimeoutRef.current = setTimeout(() => {
        if (abortControllerRef.current) {
          abortControllerRef.current.abort();
        }
        const controller = new AbortController();
        abortControllerRef.current = controller;
  
        fetchData(controller.signal)
          .catch((err) => {
            if (err.name !== "AbortError") {
              console.error("Search error:", err);
            }
          });
      }, 300);
  
      return () => {
        if (debounceTimeoutRef.current) {
          clearTimeout(debounceTimeoutRef.current);
        }
        if (abortControllerRef.current) {
          abortControllerRef.current.abort();
        }
      };
    }, [searchTerm]);

  return (
    <>
      <div className="mb-0 d-flex justify-content-between align-items-center">
        <h6 className="text-lg mb-0">Support Request</h6>
        <div className="d-flex align-items-center gap-2">
          <form className="navbar-search">
            <input
              type="text"
              name="search"
              placeholder="Search"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <span className="icon">
              <iconify-icon icon="ion:search-outline"></iconify-icon>
            </span>
          </form>
         <Tooltip title="Download Data" placement="top" arrow>
  <button className="badge text-sm fw-medium border bg-transparent px-10 py-10 radius-6 text-secondary-light">
    <SimCardDownloadOutlinedIcon />
  </button>
</Tooltip>
          {/* <button className="badge text-sm fw-medium border border bg-transparent px-10 py-10 radius-6 text-secondary-light">
            <FilterListOutlinedIcon />
          </button> */}

          <div className="dropdown">
            <Tooltip title="Manage Columns" arrow placement="top">
    <button
      className="badge text-sm fw-medium border bg-transparent px-10 py-10 radius-6 text-secondary-light"
      type="button"
      data-bs-toggle="dropdown"
      aria-expanded="false"
    >
      <ViewColumnOutlinedIcon />
    </button>
  </Tooltip>
            <ul className="dropdown-menu manage-list">
              {columnHeaders.map((column) => (
                <li
                  key={column.key}
                  className="dropdown-item d-flex align-items-center gap-2"
                >
                  <input
                    className="form-check-input"
                    style={{ width: '18px', height: '18px' }}
                    type="checkbox"
                    checked={visibleColumns[column.key]}
                    onChange={() => handleColumnToggle(column.key)}
                  />
                  <label className="ms-2">{column.label}</label>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Table */}
      <div className="table-responsive scroll-sm">
        <table
          className="table bordered-table sm-table mb-0"
          style={{
            width: '100%',
            borderCollapse: 'collapse',
            marginTop: '20px',
          }}
        >
          <thead>
            <tr style={{ background: '#f4f4f4', textAlign: 'left' }}>
              <th>#</th>
              {visibleColumns.email && <th>Email</th>}
              {visibleColumns.fullName && (
                <th className="text-center">Full Name</th>
              )}
              {visibleColumns.concern && (
                <th className="text-center">Concern</th>
              )}
              {visibleColumns.description && (
                <th className="text-center">Description</th>
              )}
              {visibleColumns.createdAt && (
                <th className="text-center">Registration Date</th>
              )}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <Loader />
            ) : (
              filteredData.map((item, index) => (
                <tr key={index}>
                  <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                  {visibleColumns.email && <td>{item.email}</td>}
                  {visibleColumns.fullName && (
                    <td className="text-center">{item.fullName}</td>
                  )}
                  {visibleColumns.concern && (
                    <td className="text-center">{item.concern}</td>
                  )}
                  {visibleColumns.description && (
                    <td className="text-center">{item.description}</td>
                  )}
                  {visibleColumns.createdAt && (
                    <td className="text-center">
                      {item.createdAt ? formatDate(item.createdAt) : ''}
                    </td>
                  )}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      <div className="d-flex justify-content-center mt-16">
        <Pagination
          count={totalPages}
          page={currentPage}
          onChange={handlePageChange}
           sx={{
    "& .MuiPaginationItem-root": {
      color: "#000",  
      border: "1px solid #ddd",
    },

    "& .Mui-selected": {
      backgroundColor: "#ff4a4a !important",  
      color: "#fff",
    },

    "& .MuiPaginationItem-root:hover": {
      backgroundColor: "#ffe5e5",
    },
  }} 
        />
      </div>
    </>
  );
}

export default SupportRequestTable;
